import { routes } from './routes';
import { createRouter, createWebHistory } from 'vue-router'
import { ROUTES } from './routeNames'
import { useAuthStore } from '@/stores/authStore'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior() {
    // always scroll to top
    return { top: 0 }
  },
})

// Global navigation guard to handle middleware
router.beforeEach(async (to, from, next) => {
  // Check if the route has middleware
  if (!to.meta.middleware) {
    return next()
  }

  const middleware = to.meta.middleware as Array<Function>

  // Create a context object to pass to middleware
  const context = {
    to,
    from,
    next,
    store: useAuthStore()
  }

  // Execute middleware
  return middleware[0]({ ...context })
})

export default router
